module.exports = __webpack_public_path__ + "static/img/kamaLOGO.adea459.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/kamaLOGO.png
// module id = R3tp
// module chunks = 1